module.exports = __webpack_public_path__ + "static/media/login.a848796e.jpg";